<script setup lang="ts">
import { computed } from 'vue';
import { UiText } from '@shopexperts/shared';

const props = defineProps<{
  title?: string;
  welcomeMessage?: string;
  description?: string;
}>();

const heading = computed(() => {
  return props.title ? props.title : `Welcome back, **${props.welcomeMessage}**!`;
});
</script>

<template>
  <div class="flex flex-col md:flex-row md:items-start justify-between mb-6 gap-4">
    <div class="flex flex-col gap-2">
      <UiText as="h1" variant="h3" :text="heading" />
      <UiText as="p" variant="p-small">
        <span v-html="description" class="prose" />
      </UiText>
    </div>
    <div v-if="$slots.action">
      <slot name="action" />
    </div>
  </div>
</template>